/*
  tn-lazy-images.js  (Sean Mythen, Sep 2026)

  Loads <img class="tn-lazy" data-src="..." data-srcset="..."> only when the
  image is within ROOT_MARGIN of the viewport, in either axis.

  Why not loading="lazy"? Chrome fetches every lazy image within ~1250px of the
  viewport (2500px on slow connections). On the homepage that is the stats bar,
  categories, press bar, transform slider and the first product slider - about
  60 images before the visitor has scrolled. This loader only fetches what is
  actually about to be seen, including horizontally in the sliders.

  Markup contract:
    <img class="tn-lazy" src="<1x1 gif>" data-src="..." data-srcset="..." sizes="..." width height>
  Keep width/height attributes so the box is reserved before the swap.

  Other scripts can force-load an element (e.g. a slider about to advance):
    window.tnLazyLoad(imgOrContainer)
*/
(function () {
  'use strict';

  var ROOT_MARGIN = '300px 250px 300px 250px';
  var SELECTOR = 'img.tn-lazy';

  function swap(img) {
    if (!img || img.dataset.tnLoaded) return;
    img.dataset.tnLoaded = '1';
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.classList.add('tn-lazy--loaded');
  }

  function loadWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(SELECTOR)) { swap(root); return; }
    var imgs = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < imgs.length; i++) swap(imgs[i]);
  }

  window.tnLazyLoad = loadWithin;

  // No IntersectionObserver (very old browsers): load everything.
  if (!('IntersectionObserver' in window)) {
    loadWithin(document);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        swap(entries[i].target);
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: ROOT_MARGIN, threshold: 0 });

  function observeAll(root) {
    var imgs = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].dataset.tnLoaded) io.observe(imgs[i]);
    }
  }

  observeAll(document);

  // Sections re-rendered by the theme editor, or markup injected later
  // (recommendations, section-renderer), get picked up here.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SELECTOR)) io.observe(node);
          else if (node.querySelectorAll) observeAll(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });

  // Images already at their real src (e.g. swapped by the editor) are harmless:
  // swap() only touches elements that still carry data-src / data-srcset.
})();
